//import Moment from "moment";

const getCount = (state) => {
	return state.implementos.length;
}

export default {
	getCount
}